import { API_URL } from './config';

export const paymentService = {
    createIntent: async (data: { amount: number; currency?: string; metadata?: any; club_id?: string; match_id?: string; tournament_id?: string; federation_id?: string; license_type_id?: string; referee_level_id?: string; description?: string; player_count?: number; breakdown?: any }) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/payments/create-intent`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Payment init failed");
        }
        return res.json();
    },
    // Wallet
    createSetupIntent: async () => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/payments/setup-intent`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });
        if (!res.ok) {
            const err = await res.json() as any;
            throw new Error(err.error || "Setup init failed");
        }
        return res.json();
    },
    listPaymentMethods: async () => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/payments/methods`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) throw new Error("Failed to list methods");
        return res.json();
    },
    detachPaymentMethod: async (methodId: string) => {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_URL}/payments/methods/${methodId}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) throw new Error("Failed to remove method");
        return res.json();
    },
    getReceiptUrl: async (params: {
        match_id?: string | number;
        tournament_id?: string | number;
        sub_order_id?: string;
        federation_id?: string;
        service_type?: 'match' | 'tournament' | 'shop' | 'licensing' | 'affiliation' | 'referee';
        club_id?: string;
    }) => {
        const token = localStorage.getItem('token');
        const urlParams = new URLSearchParams();
        if (params.match_id) urlParams.append('match_id', String(params.match_id));
        if (params.tournament_id) urlParams.append('tournament_id', String(params.tournament_id));
        if (params.sub_order_id) urlParams.append('sub_order_id', params.sub_order_id);
        if (params.federation_id) urlParams.append('federation_id', params.federation_id);
        if (params.service_type) urlParams.append('service_type', params.service_type);
        if (params.club_id) urlParams.append('club_id', params.club_id);

        const res = await fetch(`${API_URL}/payments/receipt?${urlParams.toString()}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) throw new Error("Receipt not found");
        return res.json() as Promise<{ receipt_url: string }>;
    }
};
